
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-why-how",
      function () {
        return require("private-next-pages/about-why-how.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-why-how"])
      });
    }
  